import { Scenarios } from '@jfs/network'

const appAuthApi = {
  default: [
    {
      url: /app\/authenticate/,
      method: 'POST',
      body: /GENERATE/,
      response: {
        status: 'SUCCESS',
        authorizationCode: '3b822b2c-6701-4dfa-bcbb-97fcaa613759APPACCESS',
      },
      delay: 500,
    },
    {
      url: /app\/authenticate/,
      method: 'POST',
      body: /VERIFY/,
      response: {
        status: 'SUCCESS',
        session: {
          accessToken: {
            tokenValue: '3b822b2c-6701-4dfa-bcbb-97fcaa613759APPACCESS',
            expiresIn: 1800,
          },
          refreshToken: {
            tokenValue: '0e0b2591-0e26-4cc4-babe-fd77133e9842APPREFRESH',
            expiresIn: 608400,
          },
          appIdentifierToken:
            'b71wYilOQs6BTgfRBYw75rGg1hbH3GRNMegR5hIOTpACQv9Nl9Qget02/cBUZYFN3iTAOalRrNGVi4dfT+Ta6R7UMWl5EOs9gYRVK2nws92ICL5aqbcBcvl4HKqsbN0lMdHwtBtfZjCrLKWjf52DNrfyPprGQRigsOTe8IJIUB26nXBzsBtkmF3Yc+Ku8Tym3JrZxFrJ7numkRzpvWyiCZ9YoCIRqzvEkjSb6F9Rp84Fisu12h9EeuLhTyuJYEfgXiDhl7LGegeLgYp1D5tmiyNRKdlFyZoc40nV+DRxmClhbgG8uLV/UlRBnnYcSROoOzZB66ZG1PQP8BxTTRcVabCzW/WvT4jCZep3lHbkc69wEyPVIDnp8pDP0U5u4J2E+1Nf0flIom59rtxt8xvpMH/tm6sXaRNxLN/HNmZxi0athsReBPR9IPrRCfeeB4+HpY0MB6NBhDF3cB3mcse1KZ7GbiEvAhxiCKejHzUgbwmT5IQoMbBe6M1OdB/gS4UOpiyL7/7u16psBf9zFt6mzYN4LmpyRoRVh74VvwTjTcuL2wM797/HPLWVYujXvzazvjTFQePD3EZSBi0mbYEPnkDTS+j0OhjayTUNfgFdddsDOFnPOhOBatXiw1x2/P8ZQtvhzOeEZp7xgUuevmrZ9m8RVTqNvGnBWBmQtNJLs3zQXd2otwv6a87cgDrPmURHRVKt0a4cH3FSGXYR47RBMMdtUvESmqaT7y6D5FOkOwuYcPgS/EGRH9YNRedab/ulspi3rk8XHitLW88xhYT0RkHMYIrdJGn+5t+M/zqKdlmo3E5ERTc9pBfz6cbp+vCzm6Xt6E/v84ey7/vjrDIfu9TO3gDp1TM25O+VIS6k8ICF1Mh/U5ki1aBEEBAbcykxwvIH6MnvdD4gXLVKE9Chzg5nU71a/kCB/Ea2d/g5cFhE2z/kjc3k3lg+2br+u/OnC/AAxscx2aNzdBms5AQZqw==',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /app\/authenticate/,
      method: 'POST',
      responseCode: 500,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { appAuthApi }
